export const ipaFlavourOptions = [ { key: 'FAC', value: 'gaelictools', text: 'IPA: Faclair Dictionaries'}, 
			{key: 'FULL', value: 'full', text: 'IPA: Full'}, 
			{ key: 'BLAS', value: 'akerbeltz', text: 'IPA: Blas na Gàidhlig' }];
export const defaultIpaFlavour = ipaFlavourOptions[0].value;

export const FETCHING_DATA = 'FETCHING_DATA'
export const FETCHING_DATA_SUCCESS = 'FETCHING_DATA_SUCCESS'
export const FETCHING_DATA_FAILURE = 'FETCHING_DATA_FAILURE'
export const SET_SAYTEXT = 'SET_SAYTEXT'
export const SET_IPA_FLAVOUR = 'SET_IPA_FLAVOUR'
export const RESET_FORM = 'RESET_FORM'




// WEBPACK FOOTER //
// ./src/Globals.js